import React from 'react'

const index = () => {
  return (
    <div>Attendance</div>
  )
}

export default index